// import PropTypes from "prop-types"
// import React, { useCallback, useEffect, useRef, useState } from "react"

// // //Import Scrollbar
// import SimpleBar from "simplebar-react"

// // MetisMenu
// import MetisMenu from "metismenujs"
// import withRouter from "components/Common/withRouter"
// import { Link } from "react-router-dom"

// //i18n
// import { withTranslation } from "react-i18next"
// import { useAuth } from "context/authContext"

// const SidebarContent = props => {
//   const [auth] = useAuth();
//   const [access, setAccess] = useState(null);
//   const [questionBankDisplay, setQuestionBankDisplay] = useState("block")
//   const [examSystemDisplay, setExamSystemDisplay] = useState("none")
//   const [administrationDisplay, setAdministrationDisplay] = useState("block")
//   const [studentManagementDisplay, setStudentManagementDisplay] = useState("block")
//   const [display, setDisplay] = useState({ classs: "", course: "", section: "", subSection: "", difficulty: "", question: "", questionPaper: "", schoolManagment: "", userManagment: "", studentManagment: "", centerManagment: "", language: "" });
//   const [user, setUser] = useState(null);
//   const [type, setType] = useState(null);



//   useEffect(() => {
//     let a = JSON.parse(localStorage.getItem("authUser"));
//     setUser(a);
//     setType(a.userType);

//   }, []);

//   useEffect(() => {
//     setDisplay({
//       ...display, ["classs"]: access?.classAccess, ["course"]: access?.courseAccess, ["section"]: access?.sectionAccess, ["subSection"]: access?.subSectionAccess,
//       ["difficulty"]: access?.difficultyAccess, ["language"]: access?.languageAccess, ["question"]: access?.questionAccess, ["questionPaper"]: access?.questionPaperAccess, ["schoolManagment"]: access?.
//         schoolAccess, ["userManagment"]: access?.userManagementAccess, ["studentManagment"]: access?.studentManagementAccess, ["centerManagment"]: access?.examCenterAccess,
//     })

//   }, [access])


//   useEffect(() => {
//     if (display.classs || display.course || display.section || display.subSection || display.difficulty || display.question) {
//       setQuestionBankDisplay("block");
//     }
//     if (display.questionPaper || display.schoolManagment || display.centerManagment || display.studentManagment) {
//       setExamSystemDisplay("block");
//     }
//     if (display.userManagment) {
//       setAdministrationDisplay("block");
//     }
//   }, [display])



//   const ref = useRef();
//   const activateParentDropdown = useCallback((item) => {
//     item.classList.add("active");
//     const parent = item.parentElement;
//     const parent2El = parent.childNodes[1];

//     if (parent2El && parent2El.id !== "side-menu") {
//       parent2El.classList.add("mm-show");
//     }

//     if (parent) {
//       parent.classList.add("mm-active");
//       const parent2 = parent.parentElement;

//       if (parent2) {
//         parent2.classList.add("mm-show"); // ul tag

//         const parent3 = parent2.parentElement; // li tag

//         if (parent3) {
//           parent3.classList.add("mm-active"); // li
//           parent3.childNodes[0].classList.add("mm-active"); //a
//           const parent4 = parent3.parentElement; // ul
//           if (parent4) {
//             parent4.classList.add("mm-show"); // ul
//             const parent5 = parent4.parentElement;
//             if (parent5) {
//               parent5.classList.add("mm-show"); // li
//               parent5.childNodes[0].classList.add("mm-active"); // a tag
//             }
//           }
//         }
//       }
//       scrollElement(item);
//       return false;
//     }
//     scrollElement(item);
//     return false;
//   }, []);

//   const removeActivation = (items) => {
//     for (var i = 0; i < items.length; ++i) {
//       var item = items[i];
//       const parent = items[i].parentElement;

//       if (item && item.classList.contains("active")) {
//         item.classList.remove("active");
//       }
//       if (parent) {
//         const parent2El =
//           parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
//             ? parent.childNodes[1]
//             : null;
//         if (parent2El && parent2El.id !== "side-menu") {
//           parent2El.classList.remove("mm-show");
//         }

//         parent.classList.remove("mm-active");
//         const parent2 = parent.parentElement;

//         if (parent2) {
//           parent2.classList.remove("mm-show");

//           const parent3 = parent2.parentElement;
//           if (parent3) {
//             parent3.classList.remove("mm-active"); // li
//             parent3.childNodes[0].classList.remove("mm-active");

//             const parent4 = parent3.parentElement; // ul
//             if (parent4) {
//               parent4.classList.remove("mm-show"); // ul
//               const parent5 = parent4.parentElement;
//               if (parent5) {
//                 parent5.classList.remove("mm-show"); // li
//                 parent5.childNodes[0].classList.remove("mm-active"); // a tag
//               }
//             }
//           }
//         }
//       }
//     }
//   };

//   const activeMenu = useCallback(() => {
//     const pathName = process.env.PUBLIC_URL + props.router.location.pathname;
//     let matchingMenuItem = null;
//     const ul = document.getElementById("side-menu");
//     const items = ul.getElementsByTagName("a");
//     removeActivation(items);

//     for (let i = 0; i < items.length; ++i) {
//       if (pathName === items[i].pathname) {
//         matchingMenuItem = items[i];
//         break;
//       }
//     }
//     if (matchingMenuItem) {
//       activateParentDropdown(matchingMenuItem);
//     }
//   }, [props.router.location.pathname, activateParentDropdown]);

//   useEffect(() => {
//     ref.current.recalculate();
//   }, []);

//   useEffect(() => {
//     new MetisMenu("#side-menu");
//   }, []);

//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//     activeMenu();
//   }, [activeMenu]);

//   function scrollElement(item) {
//     if (item) {
//       const currentPosition = item.offsetTop;
//       if (currentPosition > window.innerHeight) {
//         ref.current.getScrollElement().scrollTop = currentPosition - 300;
//       }
//     }
//   }

//   return (
//     <React.Fragment>
//       <SimpleBar ref={ref}>
//         <div id="sidebar-menu" >
//           <ul className="metismenu list-unstyled" id="side-menu" >

//             <li>
//               <Link to="/dashboard" className="waves-effect" style={{ background: "#ceddf0" }}>
//                 <i className="mdi mdi-view-dashboard"></i>
//                 {/* <span className="badge rounded-pill bg-primary float-end">2</span> */}
//                 <span style={{ fontSize: "1rem", color: "black", }}>{props.t("Dashboard")}</span>
//               </Link>
//             </li>

//             {/* content management  */}


//             <li className="menu-title" style={{ display: (type == "Admin" || type == "Content manager" || type == "Tata Project Manager") ? "block" : "none", fontSize: ".8rem", color: "#024076" }}>{props.t("Content Management")} </li>

//             <li style={{ display: (type == "Admin") ? "block" : "none" }}>

//               <Link to="/#" className="has-arrow waves-effect">

//                 <i className="fas fa-dice-d6"></i>
//                 <span style={{ fontSize: ".9rem", color: "black" }}>{props.t("Category")}</span>
//               </Link>
//               <ul className="sub-menu" >
//                 <li>
//                   <Link to="/create-category">{props.t("Create New Category")}</Link>
//                 </li>
//                 <li>
//                   <Link to="/all-categories">{props.t("All Categories")}</Link>
//                 </li>

//               </ul>
//               <ul className="sub-menu" >

//               </ul>
//             </li>

//             <li style={{ display: (type == "Admin") ? "block" : "none" }}>
//               <Link to="/#" className="has-arrow waves-effect">

//                 <i className="fas fa-dice-d6"></i>
//                 <span style={{ fontSize: ".9rem", color: "black" }}>{props.t("Sub Category")}</span>
//               </Link>
//               <ul className="sub-menu" >
//                 <li>
//                   <Link to="/create-sub-category">{props.t("Create New Sub Category")}</Link>
//                 </li>
//                 <li>
//                   <Link to="/all-sub-categories">{props.t("All Sub Categories")}</Link>
//                 </li>

//               </ul>
//               <ul className="sub-menu" >

//               </ul>
//             </li>

//             <li style={{ display: (type == "Admin") ? "block" : "none" }}>
//               <Link to="/#" className="has-arrow waves-effect">

//                 <i className="fas fa-dice-d6"></i>
//                 <span style={{ fontSize: ".9rem", color: "black" }}>{props.t("Level")}</span>
//               </Link>
//               <ul className="sub-menu" >
//                 <li>
//                   <Link to="/create-level">{props.t("Create New Level")}</Link>
//                 </li>
//                 <li>
//                   <Link to="/all-level">{props.t("All Levels")}</Link>
//                 </li>

//               </ul>
//               <ul className="sub-menu" >

//               </ul>
//             </li>


//             <li style={{ display: (type == "Admin" || type == "Content manager" || type == "Tata Project Manager") ? "block" : "none" }}>
//               <Link to="/#" className="has-arrow waves-effect">

//                 <i className="fas fa-dice-d6"></i>
//                 <span style={{ fontSize: ".9rem", color: "black" }}>{props.t("Course")}</span>
//               </Link>
//               <ul className="sub-menu" >
//                 <li>
//                   <Link to="/create-new-course">{props.t("Create New Course")}</Link>
//                 </li>
//                 <li>
//                   <Link to="/create-new-scorm-course">{props.t("Create New Scorm Course")}</Link>
//                 </li>
//                 <li>
//                   <Link to="/all-scorm-courses">{props.t("All Scorm Courses")}</Link>
//                 </li>
//                 <li>
//                   <Link to="/all-courses">{props.t("All Courses")}</Link>
//                 </li>

//               </ul>
//               <ul className="sub-menu" >

//               </ul>
//             </li>


//             <li className="menu-title" style={{ display: (type == "Tata Project Manager" || type == "Tata Depot Manager" || type == "Tata Trainer") ? "block" : "none", fontSize: ".8rem", color: "#024076" }}>{props.t("Training Management")} </li>
//             <li style={{ display: (type == "Tata Project Manager" || type == "Tata Depot Manager" || type == "Tata Trainer") ? "block" : "none" }}>
//               <Link to="/#" className="has-arrow waves-effect">

//                 <i className="fas fa-dice-d6"></i>
//                 <span style={{ fontSize: ".9rem", color: "black" }}>{props.t("Training")}</span>
//               </Link>
//               <ul className="sub-menu" >
//                 <li>
//                   <Link to="/training-calendar">{props.t("Training Calendar")}</Link>
//                 </li>


//               </ul>
//               <ul className="sub-menu" >

//               </ul>
//             </li>




//             {/* batch management  */}

//             <li className="menu-title" style={{ fontSize: ".8rem", color: "#024076" }}>{props.t("Batch Management")} </li>

//             <li>
//               <Link to="/#" className="has-arrow waves-effect">

//                 <i className="fas fa-dice-d6"></i>
//                 <span style={{ fontSize: ".9rem", color: "black" }}>{props.t("Batch")}</span>
//               </Link>
//               <ul className="sub-menu" >

//                 {(user?.userType == "Admin" || user?.userType == "Content manager" || user?.userType == "Tata Project Manager" || type == "Tata Depot Manager" || type == "Tata Trainer") &&
//                   <>
//                     <li>
//                       {(user?.userType == "Admin" || user?.userType == "Content manager" || user?.userType == "Tata Project Manager") &&
//                         <Link to="/create-batch">{props.t("Create New Batch")}</Link>
//                       }
//                     </li>
//                     <li>
//                       <Link to="/all-batches">{props.t("All Batches")}</Link>
//                     </li>
//                   </>
//                 }


//                 {user?.userType == "Trainer" &&
//                   <li>
//                     <Link to="/my-batches">{props.t("My Batches")}</Link>
//                   </li>
//                 }

//               </ul>
//               <ul className="sub-menu" >

//               </ul>
//             </li>


//             {/* Refer & Earn  */}

//             {(type == "Trainer" || type == "Admin") && <>
//               <li className="menu-title" style={{ fontSize: ".8rem", color: "#024076" }}>{props.t("Refer & Earn")} </li>
//             </>
//             }
//             <li style={{ display: (type == "Admin" || type == "Trainer") ? "block" : "none" }}>
//               <Link to="/#" className="has-arrow waves-effect">

//                 <i className="fas fa-dice-d6"></i>
//                 <span style={{ fontSize: ".9rem", color: "black" }}>{props.t("Referrals")}</span>
//               </Link>
//               <ul className="sub-menu" >
//                 {/*  */}
//                 {(user?.userType == "Trainer") &&
//                   <>
//                     <li>
//                       <Link to="/refer">{props.t("Refer")}</Link>
//                     </li>

//                   </>
//                 }


//                 {user?.userType == "Admin" &&
//                   <li>
//                     <Link to="/all-referrals">{props.t("All Referrals")}</Link>
//                   </li>
//                 }

//               </ul>
//               <ul className="sub-menu" >

//               </ul>
//             </li>

//             {/* student management  */}

//             <li className="menu-title" style={{ display: (type == "Admin" || type == "Tata Project Manager") ? "block" : "none", fontSize: ".8rem", color: "#024076" }}>{props.t("Candidate Management")} </li>
//             <li style={{ display: (type == "Admin" || type == "Tata Project Manager") ? "block" : "none" }}>
//               <Link to="/#" className="has-arrow waves-effect">

//                 <i className="fas fa-dice-d6"></i>
//                 <span style={{ fontSize: ".9rem", color: "black" }}>{props.t("Student")}</span>
//               </Link>
//               <ul className="sub-menu" >
//                 <li>
//                   <Link to="/create-student">{props.t("Create New Student")}</Link>
//                 </li>
//                 <li>
//                   <Link to="/all-Students">{props.t("All Students")}</Link>
//                 </li>

//               </ul>
//               <ul className="sub-menu" >

//               </ul>
//             </li>



//             {/* user management */}

//             <li className="menu-title" style={{ display: (type == "Admin" || type == "Tata Project Manager") ? "block" : "none", fontSize: ".8rem", color: "#024076" }}>{props.t("User Management")} </li>

//             {/* <li style={{ "display": display.userManagment === true ? "block" : "none " }}> */}
//             <li style={{ display: (type == "Admin" || type == "Tata Project Manager") ? "block" : "none" }}>
//               <Link to="/#" className="has-arrow waves-effect">

//                 <i className="fas fa-dice-d6"></i>
//                 <span style={{ fontSize: ".9rem", color: "black" }}>{props.t("User")}</span>
//               </Link>
//               <ul className="sub-menu" >
//                 <li>
//                   <Link to="/create-new-user">{props.t("Create New User")}</Link>
//                 </li>
//                 <li>
//                   <Link to="/all-users">{props.t("All Users")}</Link>
//                 </li>

//               </ul>
//               <ul className="sub-menu" >

//               </ul>
//             </li>

//             <li style={{ display: (type == "Admin") ? "block" : "none" }}>
//               <Link to="/#" className="has-arrow waves-effect">

//                 <i className="fas fa-dice-d6"></i>
//                 <span style={{ fontSize: ".9rem", color: "black" }}>{props.t("User Type")}</span>
//               </Link>
//               <ul className="sub-menu" >
//                 <li>
//                   <Link to="/create-new-userType">{props.t("Create User Type")}</Link>
//                 </li>
//                 <li>
//                   <Link to="/all-userTypes">{props.t("All User Types")}</Link>
//                 </li>
//               </ul>

//             </li>

//           </ul>
//         </div>
//       </SimpleBar>
//     </React.Fragment >
//   )
// }

// SidebarContent.propTypes = {
//   location: PropTypes.object,
//   t: PropTypes.any,
// }

// export default withRouter(withTranslation()(SidebarContent))





import PropTypes from "prop-types"
import React, { useCallback, useEffect, useRef, useState } from "react"

// Import Scrollbar
import SimpleBar from "simplebar-react"
import "simplebar-react/dist/simplebar.min.css"

// MetisMenu
import MetisMenu from "metismenujs"
import withRouter from "components/Common/withRouter"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"
import { useAuth } from "context/authContext"

const SidebarContent = props => {
  const [auth] = useAuth();
  const [access, setAccess] = useState(null);
  const [questionBankDisplay, setQuestionBankDisplay] = useState("block")
  const [examSystemDisplay, setExamSystemDisplay] = useState("none")
  const [administrationDisplay, setAdministrationDisplay] = useState("block")
  const [studentManagementDisplay, setStudentManagementDisplay] = useState("block")
  const [display, setDisplay] = useState({ 
    classs: "", 
    course: "", 
    section: "", 
    subSection: "", 
    difficulty: "", 
    question: "", 
    questionPaper: "", 
    schoolManagment: "", 
    userManagment: "", 
    studentManagment: "", 
    centerManagment: "", 
    language: "" 
  });
  const [user, setUser] = useState(null);
  const [type, setType] = useState(null);

  useEffect(() => {
    let a = JSON.parse(localStorage.getItem("authUser"));
    setUser(a);
    setType(a?.userType);
  }, []);

  useEffect(() => {
    setDisplay({
      ...display, 
      ["classs"]: access?.classAccess, 
      ["course"]: access?.courseAccess, 
      ["section"]: access?.sectionAccess, 
      ["subSection"]: access?.subSectionAccess,
      ["difficulty"]: access?.difficultyAccess, 
      ["language"]: access?.languageAccess, 
      ["question"]: access?.questionAccess, 
      ["questionPaper"]: access?.questionPaperAccess, 
      ["schoolManagment"]: access?.schoolAccess, 
      ["userManagment"]: access?.userManagementAccess, 
      ["studentManagment"]: access?.studentManagementAccess, 
      ["centerManagment"]: access?.examCenterAccess,
    })
  }, [access])

  useEffect(() => {
    if (display.classs || display.course || display.section || display.subSection || display.difficulty || display.question) {
      setQuestionBankDisplay("block");
    }
    if (display.questionPaper || display.schoolManagment || display.centerManagment || display.studentManagment) {
      setExamSystemDisplay("block");
    }
    if (display.userManagment) {
      setAdministrationDisplay("block");
    }
  }, [display])

  const ref = useRef();
  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const activeMenu = useCallback(() => {
    const pathName = process.env.PUBLIC_URL + props.router.location.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [props.router.location.pathname, activateParentDropdown]);

  useEffect(() => {
    if (ref.current) {
      ref.current.recalculate();
    }
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        if (ref.current && ref.current.getScrollElement()) {
          ref.current.getScrollElement().scrollTop = currentPosition - 300;
        }
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar 
        ref={ref} 
        style={{ 
          height: 'calc(100vh - 70px)',
          overflowY: 'auto',
          overflowX: 'hidden'
        }}
      >
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">

            <li>
              <Link to="/dashboard" className="waves-effect" style={{ background: "#ceddf0" }}>
                <i className="mdi mdi-view-dashboard"></i>
                <span style={{ fontSize: "1rem", color: "black" }}>{props.t("Dashboard")}</span>
              </Link>
            </li>

            {/* Content Management */}
            <li className="menu-title" style={{ 
              display: (type == "Admin" || type == "Content manager" || type == "Tata Project Manager") ? "block" : "none", 
              fontSize: ".8rem", 
              color: "#024076" 
            }}>
              {props.t("Content Management")}
            </li>

            <li style={{ display: (type == "Admin") ? "block" : "none" }}>
              <Link to="/#" className="has-arrow waves-effect">
                <i className="fas fa-dice-d6"></i>
                <span style={{ fontSize: ".9rem", color: "black" }}>{props.t("Category")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/create-category">{props.t("Create New Category")}</Link>
                </li>
                <li>
                  <Link to="/all-categories">{props.t("All Categories")}</Link>
                </li>
              </ul>
            </li>

            <li style={{ display: (type == "Admin") ? "block" : "none" }}>
              <Link to="/#" className="has-arrow waves-effect">
                <i className="fas fa-dice-d6"></i>
                <span style={{ fontSize: ".9rem", color: "black" }}>{props.t("Sub Category")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/create-sub-category">{props.t("Create New Sub Category")}</Link>
                </li>
                <li>
                  <Link to="/all-sub-categories">{props.t("All Sub Categories")}</Link>
                </li>
              </ul>
            </li>

            <li style={{ display: (type == "Admin") ? "block" : "none" }}>
              <Link to="/#" className="has-arrow waves-effect">
                <i className="fas fa-dice-d6"></i>
                <span style={{ fontSize: ".9rem", color: "black" }}>{props.t("Level")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/create-level">{props.t("Create New Level")}</Link>
                </li>
                <li>
                  <Link to="/all-level">{props.t("All Levels")}</Link>
                </li>
              </ul>
            </li>

            <li style={{ display: (type == "Admin" || type == "Content manager" || type == "Tata Project Manager") ? "block" : "none" }}>
              <Link to="/#" className="has-arrow waves-effect">
                <i className="fas fa-dice-d6"></i>
                <span style={{ fontSize: ".9rem", color: "black" }}>{props.t("Course")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/create-new-course">{props.t("Create New Course")}</Link>
                </li>
                <li>
                  <Link to="/create-new-scorm-course">{props.t("Create New Scorm Course")}</Link>
                </li>
                <li>
                  <Link to="/all-scorm-courses">{props.t("All Scorm Courses")}</Link>
                </li>
                <li>
                  <Link to="/all-courses">{props.t("All Courses")}</Link>
                </li>
              </ul>
            </li>

            {/* Training Management */}
            <li className="menu-title" style={{ 
              display: (type == "Tata Project Manager" || type == "Tata Depot Manager" || type == "Tata Trainer") ? "block" : "none", 
              fontSize: ".8rem", 
              color: "#024076" 
            }}>
              {props.t("Training Management")}
            </li>
            <li style={{ display: (type == "Tata Project Manager" || type == "Tata Depot Manager" || type == "Tata Trainer" || type=="Admin" || type=="Trainer") ? "block" : "none" }}>
              <Link to="/#" className="has-arrow waves-effect">
                <i className="fas fa-dice-d6"></i>
                <span style={{ fontSize: ".9rem", color: "black" }}>{props.t("Training")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/training-calendar">{props.t("Training Calendar")}</Link>
                </li>
              </ul>
            </li>

            {/* Batch Management */}
            <li className="menu-title" style={{ fontSize: ".8rem", color: "#024076" }}>
              {props.t("Batch Management")}
            </li>

            <li>
              <Link to="/#" className="has-arrow waves-effect">
                <i className="fas fa-dice-d6"></i>
                <span style={{ fontSize: ".9rem", color: "black" }}>{props.t("Batch")}</span>
              </Link>
              <ul className="sub-menu">
                {(user?.userType == "Admin" || user?.userType == "Content manager" || user?.userType == "Tata Project Manager" || type == "Tata Depot Manager" || type == "Tata Trainer") && (
                  <>
                    <li>
                      {(user?.userType == "Admin" || user?.userType == "Content manager" || user?.userType == "Tata Project Manager") && (
                        <Link to="/create-batch">{props.t("Create New Batch")}</Link>
                      )}
                    </li>
                    <li>
                      <Link to="/all-batches">{props.t("All Batches")}</Link>
                    </li>
                  </>
                )}

                {user?.userType == "Trainer" && (
                  <li>
                    <Link to="/my-batches">{props.t("My Batches")}</Link>
                  </li>
                )}
              </ul>
            </li>

            {/* Refer & Earn */}
            {(type == "Trainer" || type == "Admin") && (
              <li className="menu-title" style={{ fontSize: ".8rem", color: "#024076" }}>
                {props.t("Refer & Earn")}
              </li>
            )}
            <li style={{ display: (type == "Admin" || type == "Trainer") ? "block" : "none" }}>
              <Link to="/#" className="has-arrow waves-effect">
                <i className="fas fa-dice-d6"></i>
                <span style={{ fontSize: ".9rem", color: "black" }}>{props.t("Referrals")}</span>
              </Link>
              <ul className="sub-menu">
                {(user?.userType == "Trainer") && (
                  <li>
                    <Link to="/refer">{props.t("Refer")}</Link>
                  </li>
                )}

                {user?.userType == "Admin" && (
                  <li>
                    <Link to="/all-referrals">{props.t("All Referrals")}</Link>
                  </li>
                )}
              </ul>
            </li>

            {/* Candidate Management */}
            <li className="menu-title" style={{ 
              display: (type == "Admin" || type == "Tata Project Manager") ? "block" : "none", 
              fontSize: ".8rem", 
              color: "#024076" 
            }}>
              {props.t("Candidate Management")}
            </li>
            <li style={{ display: (type == "Admin" || type == "Tata Project Manager") ? "block" : "none" }}>
              <Link to="/#" className="has-arrow waves-effect">
                <i className="fas fa-dice-d6"></i>
                <span style={{ fontSize: ".9rem", color: "black" }}>{props.t("Student")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/create-student">{props.t("Create New Student")}</Link>
                </li>
                <li>
                  <Link to="/all-Students">{props.t("All Students")}</Link>
                </li>
              </ul>
            </li>

            {/* User Management */}
            <li className="menu-title" style={{ 
              display: (type == "Admin" || type == "Tata Project Manager") ? "block" : "none", 
              fontSize: ".8rem", 
              color: "#024076" 
            }}>
              {props.t("User Management")}
            </li>

            <li style={{ display: (type == "Admin" || type == "Tata Project Manager") ? "block" : "none" }}>
              <Link to="/#" className="has-arrow waves-effect">
                <i className="fas fa-dice-d6"></i>
                <span style={{ fontSize: ".9rem", color: "black" }}>{props.t("User")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/create-new-user">{props.t("Create New User")}</Link>
                </li>
                <li>
                  <Link to="/all-users">{props.t("All Users")}</Link>
                </li>
              </ul>
            </li>

            <li style={{ display: (type == "Admin") ? "block" : "none" }}>
              <Link to="/#" className="has-arrow waves-effect">
                <i className="fas fa-dice-d6"></i>
                <span style={{ fontSize: ".9rem", color: "black" }}>{props.t("User Type")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/create-new-userType">{props.t("Create User Type")}</Link>
                </li>
                <li>
                  <Link to="/all-userTypes">{props.t("All User Types")}</Link>
                </li>
              </ul>
            </li>
             <li className="menu-title" style={{ 
              display: (type == "Admin" || type == "Tata Project Manager") ? "block" : "none", 
              fontSize: ".8rem", 
              color: "#024076" 
            }}>



                {props.t("Training History Management")}
            </li>
            <li style={{ display: (type == "Admin" || type == "Tata Project Manager") ? "block" : "none" }}>
              <Link to="/#" className="has-arrow waves-effect">
                <i className="fas fa-dice-d6"></i>
                <span style={{ fontSize: ".9rem", color: "black" }}>{props.t(" Candidate History ")}</span>
              </Link>
              <ul className="sub-menu">
                {/* <li>
                  <Link to="/student-training-historyt">{props.t("Create New Student")}</Link>
                </li> */}
                <li>
                  <Link to="/student-training-history">{props.t("All Candidate History")}</Link>
                </li>
              </ul>
            </li>

          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))